//#region src/core/i18n/text/common.ts
const prefix = "common.";
const emptyText = {
	key: `${prefix}empty`,
	text: ""
};
const okText = {
	key: `${prefix}ok`,
	text: "OK"
};
//#endregion
export { emptyText, okText };

//# sourceMappingURL=common.js.map